import { ClassCategoryEnum } from "../models/enums/ClassCategoryEnum";

export const ClassCategoryColorMap: Map<ClassCategoryEnum, string> = new Map([
    [ClassCategoryEnum.Business, 'orange'],
    [ClassCategoryEnum.Couchette, 'skyblue'],
    [ClassCategoryEnum.Economy, 'green'],
    [ClassCategoryEnum.First, 'yellow'],
    [ClassCategoryEnum.Restaurant, 'red'],
    [ClassCategoryEnum.Sleeper, 'darkblue'],
    [ClassCategoryEnum.UrbanTransport, 'gray'],
]);